function _sortByPriority(autoMessages) {
    let minPriority = Number.MAX_SAFE_INTEGER;
    let prioritizedMessage;
    autoMessages.forEach(message => {
        let priority = parseInt(message['message']['priority']);
        if(minPriority > priority){
            minPriority = priority;
            prioritizedMessage = message;
        }
    })
    return prioritizedMessage;

}
function _getVisitorAutoMessageTypes(autoMessages) {
    const recurring = autoMessages.filter(autoMessage =>
        autoMessage['visitor'] === 'recurring'
    );
    const all = autoMessages.filter(autoMessage =>
        autoMessage['visitor'] === 'all'
    );
    const first = autoMessages.filter(autoMessage =>
        autoMessage['visitor'] === 'first'
    );
    return { first, recurring, all };
}
function getPriotizedAutoMessage(autoMessages){
    const {first, recurring, all} = _getVisitorAutoMessageTypes(autoMessages);
    let filteredDownAutoMessages;
    if (first.length) {
        filteredDownAutoMessages =  first;
    } else if (recurring.length) {
        filteredDownAutoMessages = recurring;
    } else {
        filteredDownAutoMessages =  all;
    }
    const prioritizedMessage = _sortByPriority(filteredDownAutoMessages);
    return prioritizedMessage;
}

export default {
    getPriotizedAutoMessage
}



// WEBPACK FOOTER //
// ./redux/selector.js